import { useEffect, useCallback } from "react";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { Box, Drawer, useTheme } from "@mui/material";
import ArrowRightAltIcon from "@mui/icons-material/ArrowRightAlt";
import { useIsMobile } from "hooks/use-breakpoint-checks.hook";
import { fillParent } from "utils/base-styles";

const Sidebar = ({ children, width = "80vw", setFn = null, toggle = true }) => {
  const dispatch = useDispatch();
  const location = useLocation();

  const isMobile = useIsMobile();
  const theme = useTheme();
  const radiusSize = theme.shape.borderRadius * 2;

  const toggleSidebar = useCallback(
    (toggle) => {
      if (setFn != null) {
        dispatch(setFn(toggle));
      }
    },
    [dispatch, setFn]
  );

  useEffect(() => {
    if (isMobile) {
      toggleSidebar(false);
    } else {
      toggleSidebar(true);
    }
  }, [isMobile, setFn, toggleSidebar, dispatch]);

  useEffect(() => {
    if (isMobile) {
      toggleSidebar(false);
    }
  }, [location, isMobile]);

  return (
    <Drawer
      open={toggle}
      onClose={() => toggleSidebar(false)}
      variant="persistent"
      sx={{
        minWidth: { xs: "unset", sm: "20vw" },
        mr: `${radiusSize}px`,
        position: { sm: "relative" },
        overflow: "unset",
        "&::before, &::after": {
          display: !isMobile ? "block" : "none",
          content: "''",
          width: radiusSize,
          height: radiusSize,
          position: "absolute",
          top: 0,
          left: "100%",
        },
        "&::before": {
          bgcolor: theme.palette.secondary.main,
        },
        "&::after": {
          bgcolor: theme.palette.background.default,
          borderTopLeftRadius: radiusSize,
        },
        "& .MuiDrawer-paper": {
          // overflowY: "unset",
          bgcolor: theme.palette.secondary.main,
          border: 0,
          position: { sm: "absolute" },
          minWidth: { xs: width, sm: "unset" },
          zIndex: isMobile ? theme.zIndex.drawer : 1,
          height: "unset",
          top: { sm: 0 },
          bottom: { xs: "56px", sm: 0 },
          left: { sm: 0 },
          right: { sm: 0 },
          overflowY: { sm: "auto" },
          direction: "rtl",
          pb: { xs: 2, sm: "unset" },
          "& > *": {
            direction: "ltr",
          },
        },
        "@media print": {
          display: "none",
        },
      }}
    >
      {isMobile && (
        <Box sx={{ pl: 3, pt: 3, pb: "0 !important" }}>
          <ArrowRightAltIcon
            onClick={() => toggleSidebar(false)}
            sx={{ cursor: "pointer" }}
          />
        </Box>
      )}
      {children}
    </Drawer>
  );
};

export default Sidebar;
